import { Controller } from "react-hook-form";
import { BaseField } from "./BaseField";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { CurrencyFieldInput } from "modules/record/shared/fields/CurrencyFieldInput";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import useGetFormValueFromDependencyField from "../../hooks/useGetFormValueFromDependencyField";
import { getFieldHelperText } from "../../services/fieldHelperText";

export const CurrencyFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => {
    const { fieldValue: currencyCodeOverride } = useGetFormValueFromDependencyField(column.depends_on_column_id);

    return (
        <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps}>
            <Controller
                name={column.name}
                control={control}
                defaultValue={column.default_value}
                rules={{ required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)) }}
                render={({ field, fieldState }) => (
                    <CurrencyFieldInput
                        column={column}
                        value={field.value ?? null}
                        onChange={field.onChange}
                        currencyCodeOverride={typeof currencyCodeOverride === "string" ? currencyCodeOverride : null}
                        disabled={runtimeProps?.readonly}
                        error={!!fieldState.error}
                        helperText={getFieldHelperText(fieldState, runtimeProps)}
                    />
                )}
            />
        </BaseField>
    );
};
